import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

// ✅ Interface matching your backend entity
export interface NatureOfDuty {
  id: number;
  nature_of_duty_id: string;
  nature_of_duty_title: string;
  sapCreatedAt?: string;
  sapModifiedAt?: string;
}

interface NatureOfDutyState {
  data: NatureOfDuty[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "nature-of-duty" | null;
}

const initialState: NatureOfDutyState = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 0,
  loading: "idle",
  error: null,
  action: null,
};

// ✅ Async Thunk to fetch nature of duty list
export const getNatureOfDutyList = createAsyncThunk(
  "natureOfDuty/fetchAll",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.OUTSIDE_JOB_NATURE.FIND_ALL, payload);
      const {
        data: { data, total, page, limit, totalPages }
      } = response.data;

      return {
        records: data,
        total,
        page,
        limit,
        totalPages,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);


// ✅ Slice
const natureOfDutySlice = createSlice({
  name: "natureOfDuty",
  initialState,
  reducers: {
    resetNatureOfDutyState: (state) => {
      state.data = [];
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNatureOfDutyList.pending, (state) => {
      state.loading = "pending";
      state.data = [];
      state.error = null;
      state.action = "nature-of-duty";
    });
    builder.addCase(getNatureOfDutyList.fulfilled, (state, action: PayloadAction<any>) => {
      state.loading = "fulfilled";
      state.data = action.payload.records;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
      state.totalPages = action.payload.totalPages;
      state.error = null;
      state.action = "nature-of-duty";
    });
    builder.addCase(getNatureOfDutyList.rejected, (state, action: PayloadAction<any>) => {
      state.loading = "rejected";
      state.error = action.payload;
      state.data = [];
      state.action = "nature-of-duty";
    });
  },
});

// ✅ Exports
export const { resetNatureOfDutyState } = natureOfDutySlice.actions;
export default natureOfDutySlice.reducer;
